// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__aUj3O","actionsCol":"EnrolledClinics_actionsCol__4lK1D"};